<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>

      <!-- 内容現在の場合 -->
      <template v-if="group1.relatedInfoTarget === 'current_contents'">
        <div class="popup current-contents">
          <div class="popup-title">
            <div class="popup-back" role="button" v-if="group1.historyCount > 0">
              <a @click.prevent="group1.goBackInHistory" class="popup-back-icn"><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></a>
            </div>
            <div class="popup-title-inner">
              <span class="hdg02">内容現在</span>
                  <p v-if="group1.current_contents_messageDisp !== ''" class="popup-title-sup mt8" v-html="group1.current_contents_messageDisp"></p>
                  <p class="txt-sup mt8">※内容現在後に施行される改正については、<IcnHistory class="icn svg-inline--fa" />をクリックすると確認できます。</p>
            </div>
          </div>
          <div class="popup-content">
            <div class="popup-content-wrapper" style="max-height:490px;min-height:80px;">

              <FontawesomeIcon v-if="!group1.isCurrentContentsLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
              <template v-else>

                <table class="current-table">
                  <colgroup>
                    <col style="width:60%;">
                    <col style="width:40%;">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>主要根拠法令</th>
                      <th>最終改正</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in group1.current_contents_list" :key="'current_contents_' + index">
                      <td class="pr20 title">{{ item.law }}</td>
                      <td>
                        <span>{{ item.last_version }}</span>
                        <span v-if="item.key !== ''" @click="group1.access(item.accessTarget, item.key, item.law)" 
                        class="button ga-qa-detail-naiyougenzai-kaiseijouhou" role="button"><IcnHistory class="icn svg-inline--fa ga-qa-detail-naiyougenzai-kaiseijouhou" /></span>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </template>

            </div>
          </div>

        </div>
      </template>
      <!-- 内容現在一覧以外（WLJP APIから取得したページ）の場合 -->
      <template v-else>
        <div class="popup wljp">

          <div class="popup-title">
            <div v-if="group1.historyCount > 0" @click.prevent="group1.goBackInHistory" class="popup-back" role="button">
              <a class="popup-back-icn"><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></a>
            </div>
            <div class="popup-title-inner">
              <span class="popup-title-main hdg02">{{ group1.relatedInfoTitle }}</span>
              <!-- <div class="button fix">
                <a href="https://go.westlawjapan.com/wljp/app/signon/display" target="_blank" class="btn">
                  詳細はWLJPへ<FontawesomeIcon icon="external-link-alt" class="icn" />
                </a>
              </div> -->
            </div>
          </div>
          <div id="wljp-print" class="popup-content">
            <div class="popup-content-wrapper" style="max-height:490px;min-height:80px;">

              <FontawesomeIcon v-if="!group1.isWLJPContentsLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
              <template v-else>
                <!-- 詳細表示の場合 -->
                <div class="navi-func-icon" v-if="group1.wljpDataType === 'detail' && group1.wljpLinkFlag === true">
                  <span role="button" class="icon ga-qa-kanrenjouhou-print"
                    @click="printTarget('related-detail-content')"
                    >
                    <span class="tip">印刷</span>
                    <FontawesomeIcon :icon="['far','print']" class="ga-qa-kanrenjouhou-print" />
                  </span>
                </div>
                <template v-if="group1.wljpDataType === 'detail'">
                  <template v-if="group1.wljpLinkFlag === true">
                    <div id="related-detail-content">
                      <div class="wljp-lc" v-html="group1.wljpContent"></div> 
                    </div>
                  </template>
                  <template v-if="group1.wljpLinkFlag === false">
                    <div class="wljp-lc" v-html="group1.wljpContent"></div> 
                  </template>
                </template>

                <!-- 一覧表示の場合 -->
                <template v-else-if="group1.wljpDataType === 'list'">

                  <!--
                    LG-001=法令の改正リスト
                    （1つの施行日に対して改正法は１つ）
                  -->
                  <template  v-if="group1.relatedInfoTarget === 'LG-001'">
                    <table class="table-relation">
                      <colgroup v-if="group1.from === 'current_contents'">
                        <col style="width:230px;">
                        <col class="safari-hack-width" style="width:calc(100% - 350px);">
                        <col style="width:120px;">
                      </colgroup>
                      <colgroup v-else>
                        <col style="width:230px;">
                        <col class="safari-hack-width" style="width:calc(100% - 230px);">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>施行日</th>
                          <th>改正法</th>
                          <th v-if="group1.from === 'current_contents'">新旧対照表</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in group1.wljpList" :key="'list_' + index">
                          <td><a @click="group1.access(item.accessTarget, item.id, item.enforcement)"  class="txt-blue" role="button">{{ item.enforcement }}</a></td>
                          <td>{{ item.revision }}</td>
                          <td v-if="group1.from === 'current_contents'"><a @click="group1.openQAOldAndNewMappings(item.accessTarget2, item.id, item.enforcement)"  class="txt-blue" role="button">新旧対照表</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </template>

                  <!--
                    LG-006=内容現在の法令の改正リスト
                    （1つの施行日に対して改正法が複数ある場合がある）
                   -->
                  <template v-else-if="group1.relatedInfoTarget === 'LG-006'">
                    <table class="table-relation">
                      <colgroup v-if="group1.from === 'current_contents'">
                        <col style="width:230px;">
                        <col class="safari-hack-width" style="width:calc(100% - 350px);">
                        <col style="width:120px;">
                      </colgroup>
                      <colgroup v-else>
                        <col style="width:230px;">
                        <col class="safari-hack-width" style="width:calc(100% - 230px);">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>施行日</th>
                          <th>改正法</th>
                          <th v-if="group1.from === 'current_contents'">新旧対照表</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in group1.wljpList" :key="'list_' + index">
                          <td v-if="item.isFirst" :rowspan="item.revisionNum"><a @click="group1.access(item.accessTarget, item.id, item.enforcement)" 
                            class="txt-blue ga-qa-detail-naiyougenzai-sekou" role="button">{{ item.enforcement }}</a></td>
                          <td>{{ item.legTitle }}<br>（{{ item.revision }}）</td>
                          <td v-if="group1.from === 'current_contents'"><a @click="group1.openQAOldAndNewMappings(item.accessTarget2, item.guid, item.enforcement)" 
                            class="txt-blue ga-qa-detail-naiyougenzai-shinkyu" role="button">新旧対照表</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </template>

                  <!-- LG-003=条文の改正リスト -->
                  <template v-else-if="group1.relatedInfoTarget === 'LG-003'">
                    <table class="popup-content-table table-relation">
                      <colgroup>
                        <col style="width:230px;">
                        <col class="safari-hack-width" style="width:calc(100% - 230px);">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>施行日</th>
                          <th>改正法</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in group1.wljpList" :key="'list_' + index">
                          <td>
                            <p @click="group1.access(item.accessTarget, item.id, item.enforcement)" 
                            class="txt-blue" role="button">{{ item.enforcement }}</p>
                          </td>
                          <td>
                            <p class="txt">{{ item.revision }}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>

                  <!-- SNLG-001=通達全文の改正リスト または SNLG-003=通達条文の改正リスト -->
                  <template v-else-if="group1.relatedInfoTarget === 'SNLG-001' || group1.relatedInfoTarget === 'SNLG-003'">
                    <table class="popup-content-table">
                      <colgroup>
                        <col style="width:100%;">
                      </colgroup>
                      <tbody>
                        <tr v-for="(item, index) in group1.wljpList" :key="'list_' + index">
                          <td>
                            <p @click="group1.access(item.accessTarget, item.id, item.revision)" 
                            class="txt-blue" role="button">{{ item.revision }}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>

                </template>

              </template>
            </div>
          </div>

          <div class="popup-footer">
            <span v-if="group1.visiblePrevPageButton" 
              @click.prevent="group1.goToPageByChunkNumber(group1.preChunkNumber)"
              role="button" class="popup-footer-link">前へ</span>
            <span v-if="group1.visibleNextPageButton" 
              @click.prevent="group1.goToPageByChunkNumber(group1.nextChunkNumber)"
              role="button" class="popup-footer-link">次へ</span>
            <!-- TODO: 【黒部】モノクロのロゴ画像を追加する style調整 -->
            <a class="pupup-footer-logo" :href="'https://go.westlawjapan.com'+group1.wljpLink" target="_blank" v-if="group1.wljpDataType === 'detail' && typeof group1.wljpLink !== 'undefined' && group1.wljpLink !== ''">
              <img src="/lc/app/images/logo-wlj.jpg" alt="WESTLAW JAPAN">
              <FontawesomeIcon icon="external-link-alt" class="icn" />
            </a>
          </div>

        </div>
      </template>
      
    </div>
    <iframe style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%; z-index: -1;" src="about:blank"></iframe>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import '@/components/style/module/WLJCSS.vue'

import * as logicQARelatedData from '@/logic/qa/QARelatedData'

export default defineComponent({
  setup (props, context) {

    const group1 = logicQARelatedData.getGroup(props, context)

    const close = () => {
      context.emit('closeRelatedData')
    }
   
    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-title {
  padding: 0 !important;
  display: table;
  width: 100%;
  .popup-back{
    display: table-cell;
    width: 100px;
    border-right: 1px solid #ddd;
    padding: 32px 0 32px 0;
    text-align: center;
    a{
      color: #005BAC;
    }
  }
  &-inner{
    display: table-cell;
    padding: 32px 150px 32px 40px
  }
  .hdg02{
    font-size: 2rem;
  }
}
.popup.current-contents {
  .popup-title {
    .hdg02 {
    }
    &-sup {
      color: $color-highlight;
      font-weight: bold;
    }
  }
  .popup-content {
    padding: 0 0 40px!important;
    &-wrapper {
      padding: 28px 40px 0;
      overflow-y: auto;
    }
    table {
      text-align: left;
      border-collapse: collapse;
      &.current-table{
        width: 100%;
      }
      caption {
        text-align: left;
        line-height: normal;
        margin-bottom: 4px;
      }
      th,td {
        padding: 16px 20px;
      }
      .title {
        color: $color-hdg;
      }
      thead {
        th {
          font-size: 1.4rem;
          color: $color-hdg;
          font-weight: normal;
        }
      }
      tbody {
        td {
          vertical-align: baseline;
          border-top: 1px solid $color-line;
          color: $color-content;
          position: relative;
          padding-right: 50px;
          .button {
            position: absolute;
            right: 20px;
            top: 24px;
            @include hoverOpacity;
            .icn {
              color: $color-link;
            }
          }
          .txt {
            font-size: 2rem;
          }
        }
      }
    }
  }
}
.popup.wljp {
  .popup-title {
    display: block!important;
    &-main,
    &-main-2 {
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
    }
    &-main-2 {
      color: $color-content;
    }
    &-sup {
      margin-bottom: 0;
    }
    .button {
      float: right;
      width: 160px;
      .btn {
        height: 36px;
      }
    }
  }
  .popup-content {
    padding: 0!important;
    &-wrapper {
      padding: 28px 40px 0;
      overflow-y: auto;
    }
    table.popup-content-table {
      width: 100%;
      tr + tr {
        th,td {
          padding-top: 20px;
        }
      }
      th,td {
        vertical-align: baseline;
        text-align: left;
      }
      th {
        .txt-blue {
          @include hoverOpacity();
        }
      }
      td {
        .txt {
          line-height: normal;
          margin-bottom: 0;
        }
      }
    }
  }
  .navi-func-icon {
    position: absolute;
    right: 110px;
    top: 33px;
    z-index: 1;
    .icon {
      color: $color-link;
      white-space: nowrap;
      margin-right: 10px;
      background-color: #fff;
      display: inline;
      padding: 5px;
      border-radius: 4px;
      border: 0;
      position: relative;
      .tip {
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translate3d(-50%,0,0);
        font-size: 1.4rem;
        font-weight: normal;
        white-space: nowrap;
        opacity: 0;
        transition: opacity .2s;
      }
      &:hover {
        box-shadow: 0 5px 20px rgba(0,0,0,.16);
        .tip {
          opacity: 1;
        }
      }
    }
  }
  .popup-footer {
    display: flex;
    justify-content: flex-start;
    text-align: center;
    align-items: center;
    height: 60px;
    margin-top: 10px;
    padding: 0 14px;
    align-items: stretch;
    align-items: center;
    &-link {
      position: relative;
      color: $color-link;
      font-size: 1.4rem;
      width: 80px;
      line-height: 30px;
      @include hoverOpacity();
      & + .popup-footer-link:before {
        content: '';
        position: absolute;
        width: 1px;
        height: 100%;
        left: 0;
        background-color: $color-line;
      }
    }
  }
  .header {
    color: $color-content;
    height: auto;
    display: block;
    border-radius: 0;
  }
}
.table-relation{
  width: 100%;
  thead{
    th{
      padding: 0 0 19px;
      border-bottom: 1px solid #ddd;
      font-weight: normal;
      text-align: left;
    }
  }
  tbody{
    tr{
      td,
      th{
        padding: 8px 0;
        border-bottom: 1px solid #ddd;
      }
      &:first-child{
        td,
        th{
          padding: 22px 0 8px;
        }
      }
    }
  }
}
.pupup-footer-logo {
  margin-left: auto;
  padding-right: 14px;
  display: flex;
  align-items: center;
  color: #005BAC;
  img {
    width: 119px;
    height: 30px;
  }
  svg.fa-external-link-alt {
    width: 1em;
    height: 1em;
    margin-left: 1em;
  }
}
@media print {
  .popup-wrapper {
    opacity: 0;
  }
}

_::-webkit-full-page-media, _:future, :root .safari-hack-width{
  width: auto !important;
}
</style>
